import script from "./ConnectedContracts.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedContracts.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedContracts.vue?vue&type=style&index=0&id=2a04dae8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a04dae8"]])

export default __exports__